/**
 * Toggle the new image creation modal
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const toggleModal = ({ commit }) => commit('TOGGLE_MODAL')

/**
 * Set the photo data after successful upload
 *
 * @param  {Function} options.commit
 * @param  {Object} data
 * @return {Promise}
 */
const setPhoto = ({ commit }, data) => commit('SET_PHOTO', data)

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Set the loading state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const setLoading = ({ commit }) => commit('SET_LOADING')

/**
 * Reset the loading state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetLoading = ({ commit }) => commit('RESET_LOADING')

export default {
    setPhoto,
    setLoading,
    resetState,
    toggleModal,
    resetLoading
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/image-uploader/actions.js